import {useState} from "react";

const Checkbox = ({checked = false, value, onChecked = (val) => {}}) => {
    const [check, setCheck] = useState(checked);

    const handleCheck = (e) => {
        onChecked(e.target.value);
        setCheck(e.target.checked);
    }

    return(
        <div className={'checkbox round-corner-5'}>
            <input checked={checked} value={value} onChange={handleCheck} type="checkbox"/>
        </div>
    )
}

export default Checkbox;
